import React, {useEffect, useState} from 'react'
import {
    useMultiStyleConfig,
    Text,
    VStack,
    Box,
} from '@salesforce/retail-react-app/app/components/shared/ui'
// COMPONENTS
import GridTemplate from '../../../components/grid-template'
import GridCard from '../../../components/grid-card'
import {FormattedMessage} from 'react-intl'
// HOOKS
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import PropTypes from 'prop-types'

//UTILS
import {remCalc} from '../../../theme/_utils'
import routingObject from '../../../utils/static-routes'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {decodeHtmlEntities} from '../../../utils/utils'

export default function CategoriesList({
    setGoBackText,
    setGoBackToPath,
    setHasSubcategory,
    onCategorySelect,
    listOfCategories,
}) {
    const navigate = useNavigation()
    const [content, setContent] = useState([])
    const styles = useMultiStyleConfig('Faq', {})
    const {categoriesCardStyles} = styles || {}
    const [showFAQcatTitle, setShowFAQcatTitle] = useState(true)
    const {locale} = useMultiSite()

    useEffect(() => {
        let countryCategories = Object.values(listOfCategories?.data || {})
        setContent(countryCategories)
    }, [listOfCategories])

    const buildUrl = (categoryName, categoryId) => {
        let cleanName = decodeHtmlEntities(categoryName)
            .trim()
            .replace(/\s+/g, '-')
            .replace(/[?]/g, '')
        let cleanId = categoryId.trim().replace(/\s+/g, '-').replace(/[?]/g, '')
        let url = `${routingObject.FAQ_PATH}/${cleanName}/t/${cleanId}`
        return url
    }

    const handleCatSelection = (cat) => {
        setShowFAQcatTitle(false)
        if (cat?.category_topics && Object.keys(cat?.category_topics).length !== 0) {
            navigate(buildUrl(cat?.category_name, cat?.category_id))
            setGoBackText('default')
            setGoBackToPath(routingObject.FAQ_PATH)
            setHasSubcategory(true)
        } else {
            navigate(buildUrl(cat?.category_name, cat?.category_id))
            setHasSubcategory(false)
        }

        const selectedCategory = cat
        onCategorySelect(selectedCategory)
    }

    return (
        <VStack w="100%" h="100%" mt={remCalc(-24)}>
            <VStack {...categoriesCardStyles?.categoriesCardContainer}>
                {showFAQcatTitle && (
                    <Text {...categoriesCardStyles?.categoriesTitle}>
                        <FormattedMessage
                            id="faq_page.categories_grid.title_message"
                            defaultMessage="Search by category to find frequently asked questions about your product."
                        />
                    </Text>
                )}
                {listOfCategories && (
                    <GridTemplate variant="faqs">
                        {content.map((cat, idx) => (
                            <Box
                                category-url={`/${locale?.alias}${buildUrl(
                                    cat?.category_name,
                                    cat?.category_id,
                                )}`}
                                w="100%"
                                textAlign="center"
                                key={idx}
                                onClick={() => handleCatSelection(cat)}
                            >
                                <GridCard
                                    title={cat?.category_name}
                                    image={cat?.category_icon}
                                    variant="faqs"
                                />
                            </Box>
                        ))}
                    </GridTemplate>
                )}
            </VStack>
        </VStack>
    )
}

CategoriesList.propTypes = {
    setGoBackText: PropTypes.func,
    setGoBackToPath: PropTypes.func,
    setHasSubcategory: PropTypes.func,
    onCategorySelect: PropTypes.func,
    listOfCategories: PropTypes.object,
}
